import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import ChildHeader from '../../../components/ui/ChildHeader';
import TController from './components/TController';
import { constants } from './constants';

const StockResister = () => {
  const [moduleData, setModuleData] = useState<any>([]);

  const { riPartId } = useParams();

  useEffect(() => {
    if (riPartId) {
      axios
        .get(`${constants.api}/${riPartId}`)
        .then((res) => {
          if (res?.data) setModuleData(res?.data);
        })
        .catch((err) => console.log(err));
    }
  }, [riPartId]);
  return (
    <>
      <Box>
        <ChildHeader text={constants.moduleName}></ChildHeader>
      </Box>
      <TController {...{ moduleData }} />
    </>
  );
};

export default StockResister;
